/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconMineWagon: {
  name: 'mine_wagon';
  data: string;
} = {
  name: 'mine_wagon',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M554.625 258v-76.319h-30.339c-20.768-37.824-37.821-91.196-84.411-118.731-53.407 1.04-102.486 61.567-153 82.871-19.639-22.651-50.852-40.033-95.625-35.859-43.471 4.047-65.996 37.074-85.631 71.719H38.25V258h20.342l46.424 175.547a52.872 52.872 0 0 0-9.391-.851c-31.687 0-57.375 28.096-57.375 62.754s25.688 62.754 57.375 62.754c31.662 0 57.332-28.051 57.373-62.671h75.321c.041 34.62 25.712 62.671 57.373 62.671s57.332-28.051 57.373-62.671h141.718l5.651-26.978h64.191v-53.789H501.7L534.536 258h20.089z"/></svg>`,
};
